/**
 * List of supported languages.
 * See: https://zopim.zendesk.com/entries/23042000-Supported-Languages-on-the-Chat-Widget
 * @type {string[]}
 */
const zopimLanguages = [
  'sq',
  'ar',
  'az',
  'bg',
  'ca',
  'zh_CN',
  'zh_TW',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fi',
  'fr',
  'ka',
  'de',
  'el',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'it',
  'ja',
  'ko',
  'ku',
  'lv',
  'lt',
  'mk',
  'ms',
  'nb',
  'fa',
  'pl',
  'pt',
  'pt_BR',
  'ro',
  'ru',
  'sr',
  'sk',
  'sl',
  'es',
  'sv',
  'tl',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
];

/**
 * Default zopim locale.
 * @type {string}
 */
const fallbackLanguage = 'en';

/**
 * Map current locale to zopim's language.
 * @param locale
 * @return {string|*}
 */
const mapLocaleToZopimLanguage = function(locale) {
  if (!locale) {
    return fallbackLanguage;
  }

  if (zopimLanguages.indexOf(locale) > -1) {
    return locale;
  }

  const language = locale.substring(0, 2);
  return zopimLanguages.indexOf(language) > -1 ? language : fallbackLanguage;
};

export default function() {
  if (ACC.liveChatEnabledOnSite && ACC.liveChatOnPage) {
    window.addEventListener('load', function() {
      /* Start of Zopim Live Chat Script */
      window.$zopim ||
        (function(d, s) {
          let z = (window.$zopim = function(c) {
              z._.push(c);
            }),
            $ = (z.s = d.createElement(s)),
            e = d.getElementsByTagName(s)[0];
          z.set = function(o) {
            z.set._.push(o);
          };
          z._ = [];
          z.set._ = [];
          $.async = !0;
          $.setAttribute('charset', 'utf-8');
          $.src = 'https://v2.zopim.com/?' + ACC.liveChatApiKey;
          z.t = +new Date();
          $.type = 'text/javascript';
          e.parentNode.insertBefore($, e);
        })(document, 'script');
      /* End of Zopim Live Chat Script */

      // Our customizations for the livechat widget
      window.$zopim(function() {
        const language = mapLocaleToZopimLanguage(ACC.languageISO);
        const liveChat = window.$zopim.livechat;

        liveChat.setLanguage(language);
        liveChat.addTags(ACC.languageISO);
        liveChat.button.setOffsetVerticalMobile(58);
        liveChat.button.setOffsetVertical(58);
        liveChat.button.setHideWhenOffline(ACC.liveChatHideWhenOffline);

        if (ACC.isB2Bsite === 'true') {
          liveChat.setName(ACC.currentUserName);
          liveChat.setEmail(ACC.currentUserEmail);
          liveChat.addTags(ACC.currentB2BUnit);
        }

        if (
          ACC.liveChatdepartmentList !== undefined &&
          Array.isArray(ACC.liveChatdepartmentList) &&
          ACC.liveChatdepartmentList.length > 0
        ) {
          liveChat.departments.filter.apply(this, ACC.liveChatdepartmentList);
          liveChat.setOnConnected(function() {
            ACC.liveChatdepartmentList.forEach(function(department) {
              let previousStatus;
              liveChat.setOnStatus(function() {
                let currentDepartment = liveChat.departments.getDepartment(department);
                let newStatus = !currentDepartment ? 'offline' : currentDepartment.status;

                if (!previousStatus || newStatus !== previousStatus) {
                  liveChat.setStatus(newStatus !== 'offline' ? 'online' : 'offline');
                  previousStatus = newStatus;
                }
              });
            });
          });
        }
      });

      $('.zopim').hide();

      // Zopim does not provide styling customization and it cannot be styled using CSS
      // Leaving us with the sole option of JS intervention
      const checkforZopimChatButtonMod = function() {
        const $zopim = $('.zopim');
        if ($zopim && $zopim.length === 2) {
          $zopim.css('border-bottom-left-radius', '5px');
          $zopim.css('border-bottom-right-radius', '5px');
        } else {
          setTimeout(function() {
            checkforZopimChatButtonMod();
          }, 200);
        }
      };
      checkforZopimChatButtonMod();
    });
  }
}
